/*
 * JuvaBun custom storefront scripts (non-cart).
 * All cart logic lives in assets/jb-cart.js.
 * Each block only runs when the elements it targets exist on the page.
 */

/* Landing page floating button (page.custom-landing-page-2): body.floating-button-active while the
   start marker has been scrolled past and the footer is not in view. */
document.addEventListener('DOMContentLoaded', function () {
  var targetElement = document.querySelector('.custom-floating-button-start');
  var endElement = document.querySelector('.shopify-section--footer');
  if (!targetElement || !endElement) return;

  var ticking = false;
  function handleScroll() {
    ticking = false;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var elementTop = targetElement.getBoundingClientRect().top;
    var endRect = endElement.getBoundingClientRect();
    var endInView = endRect.top <= window.innerHeight && endRect.bottom >= 0;
    document.body.classList.toggle('floating-button-active', scrollTop >= elementTop && !endInView);
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(handleScroll);
    }
  }, { passive: true });
  handleScroll();
});

/* Color quiz result toast (?color=Shade) */
function getUrlParameter(name) {
  return new URLSearchParams(window.location.search).get(name);
}

function showToast(color) {
  var toastOverlay = document.querySelector('.toast-overlay');
  var toast = document.createElement('div');
  toast.className = 'toast';
  toast.textContent = 'Your color match is: ';
  var value = document.createElement('span');
  value.className = 'color-value';
  value.textContent = color;
  toast.appendChild(value);
  document.body.appendChild(toast);

  setTimeout(function () {
    if (toastOverlay) toastOverlay.classList.add('open');
    toast.classList.add('show');
  }, 100);

  setTimeout(function () {
    toast.classList.remove('show');
    if (toastOverlay) toastOverlay.classList.remove('open');
    setTimeout(function () { toast.remove(); }, 300);
  }, 5000);
}

document.addEventListener('DOMContentLoaded', function () {
  var colorParam = getUrlParameter('color');
  if (colorParam && colorParam.trim() !== '') {
    showToast(colorParam);
  }

  /* "Buy now" button in snippets/buy-buttons.liquid (visibility controlled by hw-abt-9) */
  var productForm = document.querySelector('.product-info__buy-buttons form');
  var customBuyNow = document.querySelector('.custom-buynow-button');
  if (productForm && customBuyNow) {
    productForm.addEventListener('variant:change', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant) return;
      customBuyNow.dataset.vid = variant.id;
      customBuyNow.disabled = !variant.available;
    });
  }
  if (customBuyNow) {
    customBuyNow.addEventListener('click', function () {
      window.location = '/cart/' + customBuyNow.dataset.vid + ':1';
    });
  }

  /* Unit quantity radios (snippets/custom-unit-qty-selector.liquid) */
  var customUnitSelectors = document.querySelectorAll('.custom-unit-qty-radio');
  var qtyInput = document.querySelector('.quantity-selector__input');
  if (customUnitSelectors.length > 0) {
    customUnitSelectors.forEach(function (el) {
      el.addEventListener('change', function (evt) {
        if (qtyInput) qtyInput.value = evt.target.value;
      });
      if (el.checked && qtyInput) qtyInput.value = el.value;
    });

    if (productForm) {
      productForm.addEventListener('variant:change', function (evt) {
        var variant = evt.detail && evt.detail.variant;
        if (!variant || !variant.id) return;
        document.querySelectorAll('.unit-image-wrapper').forEach(function (el) {
          el.classList.toggle('hidden', el.dataset.variant != variant.id);
        });
      });
    }
  }

  /* Landing page sliders (sections/custom-slider.liquid, sections/custom-customer-reviews.liquid).
     Swiper is only loaded on the pages that use them. */
  if (typeof window.Swiper === 'undefined') return;

  if (document.querySelector('.custom-slider')) {
    new Swiper('.custom-slider', {
      spaceBetween: 30,
      loop: true,
      pagination: { el: '.custom-slider-container .swiper-pagination', clickable: true },
      navigation: {
        nextEl: '.custom-slider-container .swiper-button-next',
        prevEl: '.custom-slider-container .swiper-button-prev'
      },
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 20 },
        768: { slidesPerView: 2, spaceBetween: 20 },
        1024: { slidesPerView: 3, spaceBetween: 30 },
        1280: { slidesPerView: 3, spaceBetween: 30 }
      }
    });
  }

  if (document.querySelector('.custom-customer-reviews-section .reviews-swiper')) {
    new Swiper('.custom-customer-reviews-section .reviews-swiper', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      navigation: {
        nextEl: '.custom-customer-reviews-section .swiper-button-next',
        prevEl: '.custom-customer-reviews-section .swiper-button-prev'
      },
      breakpoints: { 612: { slidesPerView: 2 } }
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  /* Scroll-to-next-section buttons (sections/hair-product-advertisement.liquid) */
  document.querySelectorAll('.go-to-down-section').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var parentSection = el.closest('.shopify-section');
      var nextSection = parentSection && parentSection.nextElementSibling;
      if (nextSection) nextSection.scrollIntoView({ behavior: 'smooth' });
    });
  });

  /* Scroll-to-last-section buttons (sections/video-with-text.liquid) */
  document.querySelectorAll('.go-to-bottom-section').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var footerSection = document.querySelector('.shopify-section-group-footer-group.shopify-section--footer');
      var nextSection = footerSection && footerSection.previousElementSibling;
      if (nextSection) nextSection.scrollIntoView({ behavior: 'smooth' });
    });
  });

  /* UGC video slider (sections/ugc-video-slider.liquid) */
  if (!document.querySelector('.ugc-swiper')) return;

  var PLAY_ICON = '<polygon points="5 3 19 12 5 21 5 3"></polygon>';
  var PAUSE_ICON = '<rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect>';
  var allVideos = document.querySelectorAll('.ugc-slide-video');

  function resetPlayIcon(video) {
    var icon = video.closest('.ugc-slide-content') && video.closest('.ugc-slide-content').querySelector('.ugc-play-control svg');
    if (icon) icon.innerHTML = PLAY_ICON;
  }

  allVideos.forEach(function (video) {
    if (!video.hasAttribute('autoplay')) video.pause();
  });

  document.querySelectorAll('.ugc-play-control').forEach(function (button) {
    button.addEventListener('click', function () {
      var video = this.closest('.ugc-slide-content').querySelector('.ugc-slide-video');
      var playIcon = this.querySelector('svg');
      allVideos.forEach(function (other) {
        if (other !== video) {
          other.pause();
          resetPlayIcon(other);
        }
      });
      if (video.paused) {
        video.play();
        playIcon.innerHTML = PAUSE_ICON;
      } else {
        video.pause();
        playIcon.innerHTML = PLAY_ICON;
      }
    });
  });

  document.querySelectorAll('.ugc-sound-control').forEach(function (button) {
    button.addEventListener('click', function () {
      var video = this.closest('.ugc-slide-content').querySelector('.ugc-slide-video');
      var soundIcon = this.querySelector('svg');
      video.muted = !video.muted;
      soundIcon.innerHTML = video.muted
        ? '<path d="M11 5L6 9H2v6h4l5 4V5z"></path><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line>'
        : '<path d="M11 5L6 9H2v6h4l5 4V5z"></path><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>';
    });
  });

  if (typeof window.Swiper !== 'undefined') {
    var ugcSwiper = new Swiper('.ugc-swiper', {
      slidesPerView: 4,
      spaceBetween: 40,
      centeredSlides: false,
      grabCursor: true,
      loop: false,
      navigation: { nextEl: '.ugc-next-button', prevEl: '.ugc-prev-button' },
      breakpoints: {
        320: { slidesPerView: 1.2 },
        768: { slidesPerView: 2.2 },
        1024: { slidesPerView: 4 }
      }
    });
    ugcSwiper.on('slideChange', function () {
      allVideos.forEach(function (video) {
        video.pause();
        resetPlayIcon(video);
      });
    });
  }
});
